module.exports = __webpack_public_path__ + "static/media/chulalearnhub1.a83ceda9.png";